"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const react_popper_1 = require("react-popper");
const popoverConstants_1 = require("./popoverConstants");
const useForceUpdate_1 = __importDefault(require("./useForceUpdate"));
const { RIGHT_START, RIGHT_END, LEFT_START, LEFT_END } = popoverConstants_1.Placement;
const FLIP_MODIFIER = {
    name: "flip",
    options: {
        fallbackPlacements: [RIGHT_END, LEFT_START, LEFT_END]
    }
};
function usePopover(referenceElement, popperElement, { isOpen, placement = RIGHT_START }) {
    const forceUpdate = (0, useForceUpdate_1.default)();
    // we have to use forceUpdate because
    // usePopper need to run again after any refs changes, even after the first render.
    (0, react_1.useLayoutEffect)(() => {
        forceUpdate();
    }, [referenceElement, popperElement, forceUpdate]);
    const popperOptions = (0, react_1.useMemo)(() => {
        return {
            placement,
            modifiers: [
                FLIP_MODIFIER,
                {
                    name: "displayNone",
                    enabled: true,
                    phase: "write",
                    fn: ({ state }) => {
                        // eslint-disable-next-line no-param-reassign
                        state.styles.popper.visibility = isOpen ? "visible" : "hidden";
                        return state;
                    }
                }
            ]
        };
    }, [isOpen, placement]);
    const { styles, attributes } = (0, react_popper_1.usePopper)(referenceElement, popperElement, popperOptions);
    return { styles, attributes };
}
exports.default = usePopover;
